<template>
  <FormKit
    @node="
      (n) => {
        node = n;

        emit('ready', node);

        n.on('commit', (e: any) => onChange(e.payload, n));
        n.on('prop', (e: any) => {
          if (e.payload.prop == '_isFocused' && e.payload.value == true) {
            emit('focus', node);
          } else if (
            e.payload.prop == '_isFocused' &&
            e.payload.value == true
          ) {
            emit('blur', node);
          }
        });
      }
    "
    @keyup="emit('keyup', $event, node)"
  >
    <slot/>
  </FormKit>
</template>

<script setup lang="ts">
import { FormKitNode, FormKitSchemaDefinition } from "@formkit/core";
import { FormKitComponentLibrary, FormKitSchema } from "@formkit/vue";

const node = ref(null as FormKitNode | null);

withDefaults(
  defineProps<{
    data?: Record<string, any>;
    library?: FormKitComponentLibrary;
    memoKey?: string;
  }>(),
  {
    data: () => ({}),
    library: () => ({}),
  },
);

const emit = defineEmits<{
  (e: "change", value: any | null, node: FormKitNode): void;
  (e: "keyup", event: KeyboardEvent, node: FormKitNode): void;
  (e: "ready", node: FormKitNode): void;
  (e: "focus", node: FormKitNode): void;
  (e: "blur", node: FormKitNode): void;
}>();

function onChange(payload: any, node: FormKitNode) {
  // Have to apply a slight delay because Formkit is badly designed.
  setTimeout(() => {
    emit("change", payload, node);
  }, 100);
}
</script>
